import { render } from "./MediaLibrary.vue?vue&type=template&id=6f31ddd2&scoped=true"
import script from "./MediaLibrary.vue?vue&type=script&lang=js"
export * from "./MediaLibrary.vue?vue&type=script&lang=js"

import "./MediaLibrary.vue?vue&type=style&index=0&id=6f31ddd2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f31ddd2"]])

export default __exports__